import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import IconBoxStyle13 from '../../IconBox/IconBoxStyle13';

export default function HRSection({
    sectionTitle,
    sectionTitleUp,
    sectionTitleDown,
    sectionSubTitle,
    data,
}) {
    return (
        <div className="cs_shape_wrap">
            <div className="cs_shape_1 cs_position_2" />
            <div className="container">
                <SectionHeading
                    title={sectionTitle}
                    titleUp={sectionTitleUp}
                    titleDown={sectionTitleDown}
                    subTitle={sectionSubTitle}
                    center
                />
                <Spacing md="0" lg="0" />
                        <div className="cs_iconbox_3_wrap">
                          {data?.map((item, index) => (
                            <IconBoxStyle13 key={index} {...item} />
                          ))}
                        </div>
            </div>
        </div>
    );
}
